import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IconsLoader } from '@shared/services/icons/icons-loader.service';
import { fadeInOut } from '@shared/animations/fade-in-out';
import { UsersService } from 'app/shared/services/users/users.service';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'card-edit-bar',
    templateUrl: './card-edit-bar.component.html',
    styleUrls: ['./card-edit-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeInOut],
    standalone: true,
    imports: [MatIconButton, MatIcon, MatTooltip]
})
export class CardEditBarComponent implements OnInit {
  @Input() editTooltip: string;
  @Input() deleteTooltip: string;
  @Input() deleteMsg: string;

  @Input() isSoftDeleted = false;
  @Input() show: boolean;
  @Input() showEdit = true;
  @Input() editOff = false;
  @Input() showDelete = true;
  @Input() disableDelete = false;

  @Output() edit: EventEmitter<string> = new EventEmitter();
  @Output() softDelete: EventEmitter<string> = new EventEmitter();
  @Output() hardDelete: EventEmitter<string> = new EventEmitter();
  @Output() restore: EventEmitter<string> = new EventEmitter();

  locked = false;
  constructor(
    private usersService: UsersService,
    private iconsLoader: IconsLoader,
    private cd: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    this.iconsLoader.load('edit');
  }

  editItem(): void {
    this.edit.emit();
  }

  softDeleteItem(): void {
    this.locked = true;
    this.usersService.confirmAction({
      title: $localize`Confirm delete`,
      message: this.deleteMsg,
      cancelText: $localize`Cancel`,
      confirmText: $localize`Delete Item`
    }).subscribe(confirm => {
      if (confirm) {
        this.softDelete.emit();
      }
      this.locked = false;
      this.cd.detectChanges();
    });
  }

  hardDeleteItem(): void {
    this.locked = true;
    this.usersService.confirmAction({
      title: $localize`Confirm hard delete`,
      message: $localize`This item will be permanently deleted. Do you want to proceed?`,
      cancelText: $localize`Cancel`,
      confirmText: $localize`Delete Item`
    }).subscribe(confirm => {
      if (confirm) {
        this.hardDelete.emit();
      }
      this.locked = false;
      this.cd.detectChanges();
    });
  }

  restoreItem(): void {
    this.restore.emit();
  }
}
